module.exports = __webpack_public_path__ + "img/ring_r_e_1_0@3x.4c12a1b7.png";